import React from 'react';
import * as yup from 'yup';
import { dateValidation } from '../../../../util/yupUtils';
import FormSection from '../../../common/hookFormComponents/FormSection';

const fields = [
  {
    colSpan: 2,
    name: 'producedBy',
    type: 'text',
    label: 'Produced By',
    placeholder: 'Name & Address of the Mill',
    isRequired: true,
  },
  {
    colSpan: 2,
    name: 'processedBy',
    type: 'text',
    label: 'Processed By',
    placeholder: 'Name & Address of the Mill',
    isRequired: true,
  },
  {
    colSpan: 1,
    name: 'videCertificateNo',
    type: 'text',
    label: 'Vide Certificate No',
    isRequired: true,
  },
  {
    colSpan: 1,
    fieldType: 'date',
    name: 'videCertificateDate',
    label: 'Vide Certificate Date',
    isRequired: true,
  },
  {
    colSpan: 2,
    name: 'suppliedTo',
    type: 'text',
    label: 'Buyer',
    placeholder: 'Name & Address of the Mill',
    isRequired: true,
  },
];

export const millInfoFieldsValidation = {
  [fields[0].name]: yup.string().required().label(fields[0].label),
  [fields[1].name]: yup.string().required().label(fields[1].label),
  [fields[2].name]: yup.string().required().label(fields[2].label),
  [fields[3].name]: dateValidation.required().label(fields[3].label),
  [fields[4].name]: yup.string().required().label(fields[4].label),
};

const MillInformationSection = (props) => {
  return (
    <FormSection sectionName="Mill Information" sectionColumn={4} formFields={fields} {...props} />
  );
};

export default MillInformationSection;
